class Highlighter {
    constructor(tags) {
        this.tags = tags;
    }

    highlightAsXssSafeArr(text, keyword) {
        if (!text || !keyword || typeof text !== 'string' || typeof keyword !== 'string') {
            return [{ value: text }];
        }

        const escapedKeyword = keyword.replace(/([.*+?^${}()|[\]\\])/g, '\\$1');
        const regex = new RegExp(escapedKeyword, 'gi');

        const out = [];
        let lastIndex = 0;

        // `text.replace()` will call this for each match
        text.replace(regex, (match, offset) => {
            // Push plain text before match
            if (offset > lastIndex) {
                out.push({ value: text.slice(lastIndex, offset) });
            }

            // Push the highlighted match
            out.push({ value: match, className: this.tags });

            lastIndex = offset + match.length;
            return match; // return value is unused
        });

        // Push any trailing text after last match
        if (lastIndex < text.length) {
            out.push({ value: text.slice(lastIndex) });
        }

        return out.length > 0 ? out : [{ value: text }];
    }

    highlight(text, keyword) {
        return typeof this.tags === 'string'
            ? this.highlightAsXssSafeArr(text, keyword)
            : this.highlightAsRawHtmlStr(text, keyword);
    }
}

const highlighter = new Highlighter(['<span class="el-text--highlighting">', '</span>']);
const xssSafeHighlighter = new Highlighter('el-text--highlighting');

export default Highlighter;
export {
    highlighter, xssSafeHighlighter,
};
